import styled from 'styled-components';

/**
 * Height of the fixed footer bar, in pixels.
 *
 * Because the bar is `position: fixed`, it takes no space in the flow — any
 * layout that must not sit underneath it has to subtract this itself. Exported
 * so those call sites reference the real value instead of re-typing 57.
 */
export const FOOTER_HEIGHT = 57;

const FooterFlex = styled.footer`
  position: fixed;
  width: 100%;
  bottom: 0;
  right: 0;
  ${props => props.left ? `left: ${props.left}` : ''};
  display: flex;
  justify-content: ${props => props.justifyContent || 'flex-end'};
  border-top: 2px solid #EFF0EE;
  height: ${FOOTER_HEIGHT}px;
  ${props => props.width ? `width: ${props.width}` : ''};
  padding: 12px 24px;
  z-index: 3;
  box-sizing: border-box;
  overflow: hidden;
  background: white;
  align-items: center;
  button {
    margin-left: 10px;
  }
`;

export default FooterFlex;
